export const HELP_LINK = 'https://help.goodstack.org'
export const DONATION_FORM_HELP_LINK = 'https://help.goodstack.org/receiving-donations-through-goodstack#donation-form'
export const CONTACT_CUSTOMER_SERVICE_FORM_LINK = 'https://2eydnp.share-eu1.hsforms.com/2-lj6oXN4QCC95KCRwG9eNg'
export const SIDEBAR_GOODSTACK_PRO_PROMO_FORM_LINK = 'https://share-eu1.hsforms.com/2cJdTiHxxRiekHcx7aYajaQ2eydnp'
